'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'
import { AiOutlineArrowRight } from 'react-icons/ai'
import ReactPlayer from 'react-player'

export default function Hero({ params }) {
  const { session } = useAuth()
  return (
    <main className="flex flex-col align-center gap-4 bg-black">
      <main>
        <div className="relative isolate z-0">
          <img
            src="/images/home/HERObackgroundTwo.svg"
            alt="Group meeting session"
            className="w-full h-full object-cover absolute top-0 right-0"
          />

          <div className="relative overflow-hidden mt-[-170px] z-10  ">
            <div
              // className="mx-auto max-w-7xl px-6 pb-0 pt-36 sm:pt-60 lg:px-8 lg:pt-32"
              className="mx-auto max-w-7xl px-6 pb-0 pt-36 landscape:pt-48 portrait:pt-36 lg:landscape:pt-32 lg:px-8 lg:pt-32"
            >
              <AIInnovatorsHero session={session} />

              <ProgramStatsGrid session={session} />
            </div>
          </div>
        </div>
      </main>
    </main>
  )
}

const ProgramStatsGrid = (session) => {
  return (
    <FadeInStagger faster>
      <div className="grid grid-cols-1 sm:grid-cols-3 sm:gap-x-4 gap-y-4 gap-x-0 max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden col-span-2  ">
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

          <div
            style={{
              position: 'relative',
              paddingTop: '56.25%',
              borderRadius: 16,
            }}
          >
            <ReactPlayer
              width="100%"
              height="100%"
              controls={true}
              url="https://youtu.be/KcW_B-NiKzI"
              className="absolute left-0 top-0 w-full h-full object-cover "
              light={<img src="/images/home/mainBg.webp" alt="Thumbnail" />}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                borderRadius: 16,
              }}
              onClickPreview={() => {}}
              playIcon={
                <div className=" absolute inset-0 flex items-center justify-center">
                  <CustomPlayIcon />
                </div>
              }
              playing={true}
            />
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden h-[302px] sm:h-auto row-span-2 ">
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          <FadeIn>
            <img
              src="/images/home/class2.webp"
              alt="Presentation session"
              className="w-full h-full object-cover absolute top-0 left-0"
            />
          </FadeIn>
          <Link className="absolute bottom-[20px] right-[20px]" href="/about">
            <FadeIn>
              <div className="gap-2 text-[#18181B] flex items-center justify-center rounded-[8px] font-[600] w-[199px] h-[52px] px-6 text-lg bg-white hover:bg-white/80">
                Find Out More
                <CustomArrowTopIcon />
              </div>
            </FadeIn>
          </Link>
        </div>

        <div className="relative rounded-2xl overflow-hidden col-span-2 grid grid-cols-1 sm:grid-cols-3 sm:gap-y-4 sm:gap-x-4  gap-y-4 gap-x-0  ">
          <FadeIn className="col-span-3 lg:col-span-2 md:col-span-3  ">
            <FadeInStagger faster>
              <div
                style={{
                  backgroundImage: `linear-gradient(99.79deg, rgb(255 37 37 / 100%), rgb(245 189 79 / 100%))`,
                }}
                className=" rounded-2xl p-6 text-white relative col-span-2 flex flex-col justify-between overflow-hidden "
              >
                <img
                  src="/images/home/BACKGROUNDLINES.png"
                  alt="Presentation session"
                  className="w-full h-full object-cover absolute top-0 left-0 z-0"
                />
                <FadeIn>
                  <div className="flex justify-between items-center relative z-10">
                    <span className="text-[48px] leading-none font-[500]">
                      46
                    </span>

                    <Link
                      href={'/portfolio'}
                      className="backdrop-blur-[10px] border-[1.0625px] bg-[rgba(214,214,214,0.3)] hover:bg-white/40 border-white w-[45px] h-[45px] rounded-full flex items-center justify-center  "
                    >
                      <CustomWhiteArrowTopIcon />
                    </Link>
                  </div>
                </FadeIn>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mt-4 relative z-10">
                  <FadeIn>
                    <p className="text-lg text-white min-w-[max-content] ">
                      Startups Created
                    </p>
                  </FadeIn>
                  <div className="flex gap-2">
                    <FadeIn>
                      <div className="w-[40px] h-[40px] bg-[#F1F5F8] rounded-[8px] flex items-center justify-center ">
                        <img
                          className="w-[24px] h-[24px] "
                          src="/logos/s-1.webp"
                        />
                      </div>
                    </FadeIn>
                    <FadeIn>
                      <div className="w-[40px] h-[40px] bg-[#F1F5F8] rounded-[8px] flex items-center justify-center ">
                        <img
                          className="w-[24px] h-[24px] "
                          src="/logos/s-2.webp"
                        />
                      </div>
                    </FadeIn>
                    <FadeIn>
                      <div className="w-[40px] h-[40px] bg-[#F1F5F8] rounded-[8px] flex items-center justify-center ">
                        <img
                          className="w-[24px] h-[24px] "
                          src="/logos/s-3.webp"
                        />
                      </div>
                    </FadeIn>
                    <FadeIn>
                      <div className="w-[40px] h-[40px] bg-[#F1F5F8] rounded-[8px] flex items-center justify-center ">
                        <img
                          className="w-[24px] h-[24px] "
                          src="/logos/logo-7.png"
                        />
                      </div>
                    </FadeIn>
                    <FadeIn>
                      <Link
                        href={`${getApplyRedirectUrl(session)}`}
                        className="hover:bg-white/80 cursor-pointer w-[40px] h-[40px] bg-[#F1F5F8] rounded-[8px] flex items-center justify-center"
                      >
                        <CustomPlusIcon />
                      </Link>
                    </FadeIn>
                  </div>
                </div>
              </div>
            </FadeInStagger>
          </FadeIn>
          <FadeIn className="  md:col-span-3 lg:col-span-1 ">
            <div
              style={{
                backgroundImage: 'url(/images/home/intensive-3.webp)',
              }}
              className="bg-[#C9D2DD] bg-cover overflow-hidden relative rounded-2xl p-6 flex flex-col justify-between h-full"
            >
              <div
                className="absolute top-0 left-0 h-full w-full "
                style={{ background: 'rgba(53, 54, 57, 0.5)' }}
              ></div>
              <span className="text-[48px] text-white font-[500] leading-none relative z-10">
                12 Weeks
              </span>
              <p className="text-white text-lg relative z-10">
                Intensive Program
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </FadeInStagger>
  )
}
const AIInnovatorsHero = (session) => {
  return (
    <FadeInStagger faster>
      <div className="w-full landscape:mt-0 portrait:mt-[120px] lg:landscape:mt-[120px] mb-8">
        <div className=" w-full  flex flex-col sm:flex-row items-center justify-between relative z-10">
          <div className="">
            <FadeIn>
              <div className="mb-6">
                <div className="pl-1 pr-2.5 py-1 bg-white bg-opacity-10 rounded-2xl border border-[#424242] justify-start items-center gap-3 inline-flex">
                  <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                    <div className="text-center text-sm font-medium leading-5  text-white">
                      Start Your Journey!
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 flex">
                    <div className=" text-xl font-medium leading-5 flex items-center">
                      <Link
                        href={'/about'}
                        className="text-center text-sm font-medium leading-5  text-white "
                      >
                        About the Hybrid Program
                      </Link>
                    </div>
                    <AiOutlineArrowRight className="text-[14px] leading-5 font-medium text-[#fff] mr-1" />
                  </div>
                </div>
              </div>
            </FadeIn>

            <FadeIn>
              <h1 className="text-[44px] sm:text-[56px] font-medium mb-6 text-white">
                Forging AI Leaders Through Challenges and Elite Connections
              </h1>
            </FadeIn>
          </div>
          <div>
            <FadeIn>
              <p className="text-[20px] text-white mb-8">
                Where Ambition Meets Opportunity to Shape the Future of AI
              </p>
            </FadeIn>
            <FadeIn>
              <Link
                href={`${getApplyRedirectUrl(session)}`}
                className="bg-white hover:bg-white/80 text-[#18181B] text-lg  hover:bg-gray-100 px-6 py-3 rounded-[8px] h-[52px] font-[600] inline-flex items-center transition-all"
              >
                Apply Now
                <span className="ml-2">
                  {' '}
                  <CustomArrowTopIcon />
                </span>
              </Link>
            </FadeIn>
          </div>
        </div>
      </div>
    </FadeInStagger>
  )
}

const CustomPlayIcon = () => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_7326_51454)">
        <circle
          cx="34"
          cy="34"
          r="33.4687"
          fill="#D6D6D6"
          fill-opacity="0.3"
          stroke="white"
          stroke-width="1.0625"
        />
        <path
          d="M47.5533 32.6821C48.6072 33.2712 48.6072 34.7288 47.5533 35.3179L28.4283 46.0076C27.3401 46.6158 26.0312 45.8386 26.0312 44.6897L26.0313 23.3103C26.0313 22.1614 27.3401 21.3842 28.4283 21.9924L47.5533 32.6821Z"
          stroke="white"
          stroke-width="1.0625"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_7326_51454"
          x="-20"
          y="-20"
          width="108"
          height="108"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_7326_51454"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_7326_51454"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
const CustomWhiteArrowTopIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.92893 9.00002H16.0711M16.0711 9.00002L9 1.92896M16.0711 9.00002L9 16.0711"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const CustomPlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5V19.5M19.5 12L4.5 12"
        stroke="#3E5AED"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const CustomArrowTopIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11L11 1M11 1H1M11 1V11"
        stroke="#101828"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
